import MenuCard from '@/core/components/MenuCard/MenuCard';

export default MenuCard;
